import {defineStore} from "pinia";
import {Cajero} from "@/models/Cajero";
import {User} from "@/models/User";
import {Funcionario} from "@/models/Funcionario";

export const cajeroStore = defineStore("cajeroStore", {
    state: () =>
        ({
            loading: false as boolean,
            showDialog: false as boolean,
            showDialogFuncionario: false as boolean,
            cajeros: [] as Cajero[],
            cajero: new Cajero() as Cajero,

            usuarios: [] as User[],
            funcionario: new Funcionario() as Funcionario,
        }),
});